import React from "react";

export const HeartBreak = (props) => {
  return (
    <svg
      id="Layer_1"
      dataname="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 20"
      {...props}
    >
      <path
        d="M18,12c1.49-1.46,3-3.21,3-5.5,0-3.04-2.46-5.5-5.5-5.5-1.76,0-3,.5-4.5,2-1.5-1.5-2.74-2-4.5-2C3.46,1,1,3.46,1,6.5c0,2.3,1.5,4.05,3,5.5l7,7,7-7Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M10.99,18.25v-3.67l-1.45-1.45,2.9-2.9-4.34-4.34,2.9-2.9"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};
